import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  Product,
} from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { UntypedFormArray } from '@angular/forms';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ProductDao } from '@app/dao/product/product.dao';
import { CompanyFieldType } from '../../definition/interface/enum';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'pourcentage-de-remise-form',
    templateUrl: './pourcentage-de-remise-form.component.html',
    styleUrls: ['./pourcentage-de-remise-form.component.scss'],
    standalone: false
})
export class PourcentageDeRemiseFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;
  products: Product[] = [];
  rcdaComparedProductsChoices: Product[] = [];
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  organizationId: number;
  productType: string;
  productIds: number[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
    protected attributionDao: AttributionDao,
  ) {
    super(formConstructor);
  }

  ngOnInit(): void {
    const pledge = this.subscriptionFacade.getPledge();
    const { products = [], parameters = {} as Parameters } = pledge || {};
    const productIds =
      parameters?.additionalQuestions?.find(
        ({ id }) => id == CompanyFieldType.POURCENTAGE_DE_REMISE,
      )?.productIds || [];

    const matchingProducts = this.getMatchingProducts(productIds, products);
    this.products = matchingProducts || [];
    this.productIds =
      matchingProducts?.map(product => product?.productId) || [];

    this.initForm(pledge?.products || []);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(this, 'products');
    }
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(
        this,
        'products',
        false,
        this.nextStep.bind(this),
        true,
      );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }

  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }

  getMatchingProducts(
    questionIds: number[],
    productList: Product[],
  ): Product[] {
    return productList.filter(product =>
      questionIds?.includes(product?.productId),
    );
  }
}
